// extracted by mini-css-extract-plugin
module.exports = {"actions":"_18696","icon":"_8147"};